import { useTranslation } from "next-i18next";
// import React from "react";
import { Button } from "@climate-science/component-library";

import { Map } from "@cs/components/primitive/map/Map";
import { FaAngleRight } from "react-icons/fa";
import styles from "./PartnershipsHero.module.scss";
import { NextSeo } from "next-seo";

export const PartnershipsHero = () => {
  const { t } = useTranslation("partnerships")
  return (
    <section className={styles.hero}>
      <NextSeo 
        title={t('partnerships')}
      />
      <h1 className={styles.title}>{t("title")}</h1>
      <p>{t("subtitle")}</p>
      <Button primary Icon={FaAngleRight} className={styles.applybutton}>
        {t("apply")}
      </Button>
      <Map
        mapUrl="https://www.google.com/maps/d/u/1/kml?mid=1n3XyJs96VyocWG-n8HqwThBRUOjV32Sv"
        apiKey={process.env.NEXT_PUBLIC_API_KEY ?? ''}
        mapContainerClassName={styles.map}
      />
    </section>
  )
}
